module.exports = __webpack_public_path__ + "static/media/logo-main-white.d2001c1e.svg";